<app-modal
  #unFavModal
  [modalMessage]="app.text.thread.unFavCaseMessage"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="setFav(false)"
  >
</app-modal>

<div class="row">
  <div class="col-sm-12 col-md-12 col-12">
    <!-- First line -->
    <div class="row py-3">
      <!-- Left side -->
      <!-- Switch view buttons -->
      <div class="col-2">
        <div class="btn-group btn p-0">
          <button
            type="button"
            class="btn btn-light btn-toggle-list icon-center"
            [ngClass]="{ selected: app.home.homeMode === 'list' }"
            (click)="setHomeMode('list')"
            [ngbTooltip]="app.text.home.list"
            >
            <i
              class="far fa-stream menu-icons"
              [ngClass]="{ selected: app.home.homeMode === 'list' }"
            ></i>
          </button>
          <button
            type="button"
            class="btn btn-light btn-toggle-list icon-center"
            [ngClass]="{ selected: app.home.homeMode === 'table' }"
            (click)="setHomeMode('table')"
            [ngbTooltip]="app.text.home.table"
            >
            <i
              class="fal fa-table menu-icons"
              [ngClass]="{ selected: app.home.homeMode === 'table' }"
            ></i>
          </button>
        </div>
        <div class="btn-group btn-sm">
          @if (app.home.homeMode === 'list') {
            <span>{{
              app.text.home.listView
            }}</span>
          }
          @if (app.home.homeMode === 'table') {
            <span>{{
              app.text.home.tableView
            }}</span>
          }
        </div>
      </div>

      <!-- Right side -->

      <div class="col-10 d-flex flex-row-reverse">
        <div class="btn-group">
          <!-- Quick filters -->
          <div class="dropdown quickFilters">
            <button
              class="btn dropdown-toggle"
              type="button"
              id="quickFilters"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >
              <div class="icon-center me-1">
                <i class="fas fa-eye menu-icons"></i>
              </div>
              <span>&nbsp;{{ app.text.home.showOnly }}&nbsp;</span>
              <span class="text-danger">
                {{
                app.filterFields.getQuickFilterText(
                app.filterFields.quickFilterSelected
                )
                }}
              </span>
            </button>
            <div
              id="quickFiltersDropdown"
              class="dropdown-menu"
              aria-labelledby="quickFilters"
              role="menu"
              >
              @for (item of quickFilters; track item) {
                <a
                  class="dropdown-item pointer"
                  (click)="app.filterFields.addQuickFilter(item)"
                  >{{ app.text.home[item] }}</a
                  >
                }
              </div>
            </div>

            <!-- Sort Options -->
            @if (app.home.homeMode === 'list') {
              <div
                class="dropdown sortOptions"
                >
                <button
                  class="btn dropdown-toggle"
                  type="button"
                  id="sortOptions"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >
                  <div class="icon-center me-1">
                    <i class="fas fa-sort-alt menu-icons"></i>
                  </div>
                  <span>&nbsp;{{ app.text.home.sort }}&nbsp;</span>
                  @if (app.table.sortField) {
                    <span class="text-danger">
                      {{ app.field.getLabel(app.table.sortField) }}
                      <small class="text-muted">
                        ({{
                        app.table.sortDirection === -1
                        ? app.text.home.newestFirst
                        : app.text.home.oldestFirst
                        }})
                      </small>
                    </span>
                  }
                </button>
                <div class="dropdown-menu" aria-labelledby="sortOptions">
                  @for (item of app.list.thread.sortOptions; track item) {
                    <a
                      class="dropdown-item pointer"
                      (click)="toggleSort(item)"
                      >
                      {{ app.field.getLabel(item) }}
                      @if (item === app.table.sortField) {
                        <span>
                          ({{
                          app.table.sortDirection === -1
                          ? app.text.home.oldestFirst
                          : app.text.home.newestFirst
                          }})
                        </span>
                      }
                    </a>
                  }
                </div>
              </div>
            }

            <!-- Export Types -->
            @if (app.permission.home.download) {
              <div class="dropdown">
                @if (app.list.thread.exportTypes.length > 1) {
                  <div>
                    <button
                      class="btn btn-sm dropdown-toggle"
                      type="button"
                      id="exportTypeButton"
                      data-bs-toggle="dropdown"
                      [title]="app.text.home.export"
                      aria-haspopup="true"
                      aria-expanded="false"
                      >
                      <div class="icon-center me-1">
                        <i class="fa fa-download menu-icons"></i>
                      </div>
                      <span>&nbsp;{{ app.text.home.exportList }}&nbsp;</span>
                      <span class="text-danger">
                        {{ getExportTypeText(app.thread.exportType) }}
                      </span>
                    </button>
                    <div
                      class="dropdown-menu exportTypeDropdown"
                      aria-labelledby="exportTypeButton"
                      >
                      @for (item of app.list.thread.exportTypes; track item) {
                        <div>
                          @if (item === 'All Cases json' && app.auth.isAdmin) {
                            <a
                              class="dropdown-item pointer"
                              (click)="writeFile(item)"
                              >
                              {{ getExportTypeText(item) }}</a
                              >
                            }
                            @if (item !== 'All Cases json') {
                              <a
                                class="dropdown-item pointer"
                                (click)="writeFile(item)"
                                >
                                {{ getExportTypeText(item) }}</a
                                >
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (app.list.thread.exportTypes.length === 1) {
                      <div>
                        <button
                          class="btn btn-sm"
                          type="button"
                          id="exportTypeButton"
                          [title]="app.text.home.export"
                          (click)="writeFile('All Cases')"
                          >
                          <div class="icon-center me-1">
                            <i class="fa fa-download menu-icons"></i>
                          </div>
                          <span>&nbsp;{{ app.text.home.exportList }}&nbsp;</span>
                          <!-- <span class="text-danger">
                          {{ getExportTypeText(app.thread.exportType) }}
                        </span> -->
                      </button>
                    </div>
                  }
                </div>
              }

              <!-- Display only internal cases by default for all customers, but not SBB -->
              @if (app.customer === 'omp') {
                <div>
                  @if (!app.filterList.showExternalCases) {
                    <button
                      class="btn btn-sm"
                      (click)="app.filterList.toggle()"
                      [ngbTooltip]="app.text.home.showAllCases"
                      >
                      <div class="icon-center me-1">
                        <i class="fas fa-layer-plus menu-icons"></i>
                      </div>
                      <span>&nbsp;{{ app.text.home.showAllCases }}&nbsp;</span>
                    </button>
                  }
                  @if (app.filterList.showExternalCases) {
                    <button
                      class="btn btn-sm"
                      (click)="app.filterList.toggle()"
                      [title]="app.text.home.showInternalCases"
                      >
                      <div class="icon-center me-1">
                        <i class="fas fa-layer-minus menu-icons"></i>
                      </div>
                      <span>&nbsp;{{ app.text.home.showInternalCases }}&nbsp;</span>
                    </button>
                  }
                </div>
              }

              <!-- Filter button -->
              <div>
                <button
                  class="btn btn-sm btn-default-red me-1"
                  data-toggle="collapse"
                  data-target="#collapseFilter"
                  [disabled]="!listReady"
                  (click)="app.filterList.open = !app.filterList.open"
                  [title]="app.text.home.filters"
                  [ngClass]="{ btnFilterOpen: app.filterList.open }"
                  >
                  <i class="fas fa-filter"></i>
                  {{ app.text.home.filters }}
                  @if (!app.filterList.open) {
                    <i class="fal fa-angle-right"></i>
                  }
                  @if (app.filterList.open) {
                    <i class="far fa-times ml-1"></i>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Second line -->
        <div class="row bottom-line">
          <!-- Right side -->
          <div class="col-12">
            <!-- Filter cips -->
            @if (listReady) {
              <div class="col-8 pull-right no-padding">
                <app-filter-fields></app-filter-fields>
              </div>
            }
          </div>
        </div>

        @if (!listReady) {
          <div class="col-md-12 text-center font-weight-bold">
            {{ app.text.app.loading }}
          </div>
        }
        @if (listReady) {
          <div>
            <div>
              @switch (app.home.homeMode) {
                @case ('list') {
                  <div>
                    <app-paginator
                      [length]="app.thread.pages"
                      [index]="app.paginator.focus"
                      (focus)="app.paginator.focus = $event"
                      [type]="'thread'"
                    ></app-paginator>
                    @if (app.thread.ids.length == 0) {
                      <div class="no-results col-12">
                        {{ app.text.home.noResults }}
                      </div>
                    }
                    @for (id of app.thread.ids; track id) {
                      <div>
                        <a [routerLink]="app.thread.getRouterURL(id)">
                          <app-thread-item [id]="id"></app-thread-item>
                        </a>
                      </div>
                    }
                    <app-paginator
                      [length]="app.thread.pages"
                      [index]="app.paginator.focus"
                      (focus)="app.paginator.focus = $event"
                      [type]="'thread'"
                    ></app-paginator>
                  </div>
                }
                @case ('table') {
                  <div>
                    <app-paginator
                      [length]="app.thread.pages"
                      [index]="app.paginator.focus"
                      (focus)="app.paginator.focus = $event"
                      [type]="'thread'"
                    ></app-paginator>
                    <div class="tableFixHead">
                      <table class="table table-striped spacing-table">
                        <thead>
                          <tr>
                            @for (column of app.list.thread.columns; track column) {
                              <th
                                class="p-1 py-2"
                                >
                                <div>
                                  <span (click)="toggleSort(column)">{{
                                    app.field.handleSpecialLogicLabels(column)
                                    }}</span
                                    >&nbsp;
                                    @if (column === app.table.sortField) {
                                      <span>
                                        @if (app.table.sortDirection === 1) {
                                          <i
                                            class="fa fa-chevron-up"
                                          ></i>
                                        }
                                        @if (app.table.sortDirection === -1) {
                                          <i
                                            class="fa fa-chevron-down"
                                          ></i>
                                        }
                                      </span>
                                    }
                                  </div>
                                </th>
                              }
                            </tr>
                          </thead>
                          @if (listReady) {
                            <tbody>
                              @for (case of app.paginator.getPageWithDoc(); track case) {
                                <tr
                                  [ngClass]="{ caseClosed: case.omfStatus === '120' }"
                                  class="pointer"
                                  (click)="app.routing.navigateThread(case._id)"
                                  >
                                  @for (column of columns; track column) {
                                    <td class="p-1">
                                      <a
                                        [routerLink]="app.thread.getRouterURL(case._id)"
                                        class="no-style"
                                        >
                                        <div>
                                          @switch (app.table.getColumnTypeDisplay(column)) {
                                            @case ('fav') {
                                              <div>
                                                <div
                                                  class="col-md-12"
                            (click)="
                              app.thread.thread = case;
                              setFav(true);
                              $event.stopPropagation();
                              $event.preventDefault()
                            "
                                                  >
                                                  <i
                              [ngClass]="{
                                'far fa-star': !app.thread.isFav(case._id)
                              }"
                                                    [ngStyle]="{ color: '#787ABF' }"
                                                  ></i>
                                                </div>
                                                <div
                                                  class="col-md-12"
                            (click)="
                              unFavModal.open();
                              app.thread.thread = case;
                              $event.stopPropagation();
                              $event.preventDefault()
                            "
                                                  >
                                                  <i
                              [ngClass]="{
                                'fas fa-star': app.thread.isFav(case._id)
                              }"
                                                    [ngStyle]="{ color: '#787ABF' }"
                                                  ></i>
                                                </div>
                                              </div>
                                            }
                                            @case ('dueDate') {
                                              <div>
                                                @if (case[column] > 0) {
                                                  <span
                                                    class="due-date"
                                                    [ngStyle]="app.thread.getDueDateStyle(case)"
                                                    >
                                                    {{ case[column] | date : "yyyy-MM-dd" : "UTC" }}
                                                  </span>
                                                }
                                              </div>
                                            }
                                            @case ('limit') {
                                              <div class="fixedWidth">
                                                <span
                            (click)="
                              $event.stopPropagation(); $event.preventDefault()
                            "
                                                  >
                                                  <app-limit
                              [textInput]="
                                app.field.getItemsAsString(case[column], column)
                              "
                                                    limit="50"
                                                    [fieldName]="vehicleNames"
                                                    >
                                                  </app-limit>
                                                </span>
                                              </div>
                                            }
                                            @case ('time') {
                                              <div>
                                                @if (case[column] > 0) {
                                                  <span>
                                                    {{ case[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                                                  </span>
                                                }
                                              </div>
                                            }
                                            @case ('date') {
                                              <div>
                                                @if (case[column] > 0) {
                                                  <span>
                                                    {{ case[column] | date : "yyyy-MM-dd" : "UTC" }}
                                                  </span>
                                                }
                                              </div>
                                            }
                                            @case ('optionText') {
                                              <div>
                                                <span>
                                                  {{
                                                  app.field.getOptionText(
                                                  "thread." + column,
                                                  case[column]
                                                  )
                                                  }}
                                                </span>
                                              </div>
                                            }
                                            @case ('getShortText') {
                                              <div>
                                                @for (option of case[column]; track option; let i = $index) {
                                                  <span>
                                                    {{
                                                    app.field.getOptionShort(
                                                    "post.resolveClass",
                                                    option
                                                    )
                                                    }}
                                                  </span>
                                                }
                                              </div>
                                            }
                                            @case ('getFieldValueAsText') {
                                              <div>
                                                <span>
                                                  {{
                                                  app.field.getFieldValueAsText(
                                                  "thread." + column,
                                                  case[column]
                                                  )
                                                  }}
                                                </span>
                                              </div>
                                            }
                                            @case ('artNumber') {
                                              <div>
                                                {{ case[column] }}
                                              </div>
                                            }
                                            @case ('getUser') {
                                              <div>
                                                {{ app.users.getOptionName(case[column]) }}
                                              </div>
                                            }
                                            @case ('normal') {
                                              <div>
                                                {{ case[column] }}
                                              </div>
                                            }
                                          }
                                        </div>
                                      </a>
                                    </td>
                                  }
                                </tr>
                              }
                              <tr>
                                @if (app.thread.ids.length === 0) {
                                  <td
                                    colspan="99"
                                    class="text-center"
                                    >
                                    {{ app.text.home.noResults }}
                                  </td>
                                }
                              </tr>
                            </tbody>
                          }
                        </table>
                      </div>
                      <app-paginator
                        [length]="app.thread.pages"
                        [index]="app.paginator.focus"
                        (focus)="app.paginator.focus = $event"
                        [type]="'thread'"
                      ></app-paginator>
                    </div>
                  }
                  <!-- <div *ngSwitchCase="'posts-list'">
                  <app-paginator
                    [length]="app.post.ids.length"
                    [index]="app.paginator.focus"
                    (focus)="app.paginator.focus = $event"
                  ></app-paginator>
                  <app-paginator
                    [length]="app.post.ids.length"
                    [index]="app.paginator.focus"
                    (focus)="app.paginator.focus = $event"
                  ></app-paginator>
                </div> -->
                @default {
                  <div>Unknown: {{ app.home.homeMode | json }}</div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
